/** shipments group: shipments, participants, release (shipment:release_override is grant-only below owner) (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const shipmentsPermissions = [
  'shipment:read',
  'shipment:write',
  'shipment:transition',
  'shipment:finance_lock',
  'shipment:withdraw',
  'shipment:release_override',
  'shipment:collaborate',
] as const;

export type ShipmentsPermission = (typeof shipmentsPermissions)[number];
